import ItemShelfCard from '@/components/GridItemCard/Card/CardOptions/ItemShelfCard/ItemShelfCard';
import TimedShelfCard from '@/components/GridItemCard/Card/CardOptions/TimedShelfCard/TimedShelfCard';
import { ItemCardComponent, ItemCardInfo } from '@/components/GridItemCard/types/types';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryIsTimedPlusAuction } from '@/redux/modules/item/summary/itemSummary.selectors';

const TimedOrItemShelfCard: ItemCardComponent = (props) => {
    const isTimedPlus = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, props.itemId));

    const Component = isTimedPlus ? TimedShelfCard.ItemCardComponent : ItemShelfCard.ItemCardComponent;

    return <Component {...props} />;
};

const info: ItemCardInfo = { ItemCardComponent: TimedOrItemShelfCard };

export const CarouselItemShelfCard: ItemCardInfo = {
    ItemCardComponent: TimedOrItemShelfCard,
};

export default info;
